<template>
  <q-btn label="Import Posts" v-bind="$attrs" @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { Account } from '@/iam/types';
import ImportPostsModal from './ImportPostsModal.vue';

export default defineComponent({
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  methods: {
    openModal(): void {
      const config = {
        parent: this,
        account: this.account,
      };
      openModal(ImportPostsModal, config);
    },
  },
});
</script>
